import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Shield, Loader2 } from "lucide-react";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API_BASE}/api/admin/login`, { email, password }, { withCredentials: true });
      if (r.data?.token) localStorage.setItem("lm_admin_token", r.data.token);
      toast.success("Signed in.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[color:var(--lm-dark)] flex items-center justify-center px-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-xl bg-white/10 flex items-center justify-center mx-auto mb-4">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-3xl font-display font-semibold text-white">Admin panel</h1>
          <p className="text-white/60 text-sm mt-1">Leadmato control room · staff only</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-xl p-6 shadow-2xl">
          <label className="block text-xs font-mono uppercase tracking-widest text-lm-text3 mb-1.5">Email</label>
          <input
            type="email"
            data-testid="admin-login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-lm-border rounded-lg px-4 py-2.5 mb-3 text-sm focus:outline-none focus:ring-2 focus:ring-lm-primary/20 focus:border-lm-primary"
            required
            autoFocus
          />
          <label className="block text-xs font-mono uppercase tracking-widest text-lm-text3 mb-1.5">Password</label>
          <input
            type="password"
            data-testid="admin-login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-lm-border rounded-lg px-4 py-2.5 mb-5 text-sm focus:outline-none focus:ring-2 focus:ring-lm-primary/20 focus:border-lm-primary"
            required
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-lm-primary text-white rounded-lg px-5 py-2.5 font-semibold hover:bg-lm-primaryHover disabled:opacity-60"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Shield className="w-4 h-4" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
